// AUTO-SPLIT FROM translations.ts — language-specific dictionary.
// Loaded dynamically by LanguageContext for non-default languages.
// Keep keys aligned across en/es/pt.

const dict = {
  "nav.howItWorks": "How It Works",
  "nav.whatWeSource": "What We Source",
  "nav.about": "About",
  "nav.insights": "Insights",
  "nav.solutions": "Solutions",
  "nav.kits": "Pre-Configured Power Packages",
  "nav.engineeredSolutions": "Power Distribution Solutions",
  "nav.industries": "Industries",
  "nav.caseStudies": "Case Studies",
  "nav.engineered": "Power Distribution Solutions",
  "nav.fastAccess": "Fast Access Power Components",
  "nav.fastAccess.desc": "High-demand components, sourced and delivered quickly",
  "nav.kits.desc": "Standardized, ready-to-deploy power systems",
  "nav.engineered.desc": "Engineered systems for complex requirements",
  "nav.getQuote": "Get Pricing",
  "cta.requestQuote": "Get Pricing & Availability",
  "cta.sendWhatsapp": "Send RFQ via WhatsApp",
  "cta.uploadBom": "Upload BOM",
  "cta.getQuoteHours": "Get Pricing & Availability",
  "cta.askSwitzh": "Ask Switzh",
  "cta.askSwitzh.sub": "AI sourcing assistant for parts, BOMs, and RFQs",
  "cta.chatWhatsapp": "Chat on WhatsApp",
  "cta.responseExpectation": "Get pricing, availability, and lead times within hours",
  "hero.proofLine": "Submit SKU, link, or product details \u2014 receive structured pricing and delivery.",
  "hero.microNoAccount": "No account required",
  "hero.microResponse": "Response in minutes",
  "cta.activityProof": "Recent requests from: Bogot\u00e1, Mexico City",
  "cta.whatHappensNext": "We review your request and send pricing + availability within a few hours",
  "hero.badge": "U.S. Electrical Supply \u2192 LATAM \u00b7 Quotes in <4 hours",
  "hero.h1.part1": "Switchgear & Electrical Infrastructure",
  "hero.h1.part2": "Sourcing for LATAM",
  "hero.subtitle": "Source from U.S. electrical distributors with delivered pricing, fast RFQs, and coordinated cross-border execution.",
  "hero.systemLine": "Quotes in <4 hours. Landed (DDP) pricing upfront. Built for LATAM procurement.",
  "hero.systemLine.label": "Built for",
  "hero.systemLine.desktop": "Electrical contractors, industrial maintenance teams, and procurement teams sourcing U.S. components",
  "hero.subtitle.mobile": "Source from U.S. electrical distributors with delivered pricing, fast RFQs, and coordinated cross-border execution.",
  "infraStrip.label": "Infrastructure layer",
  "infraStrip.1": "Operating across LATAM",
  "infraStrip.2": "Global supplier network",
  "infraStrip.3": "Structured quotes with verified delivery",
  "scaleStrip.label": "Scale & reach",
  "scaleStrip.1": "Serving projects across LATAM",
  "scaleStrip.2": "Sourcing from a verified U.S. supplier network",
  "scaleStrip.3": "Quote turnaround typically within hours",
  "categoryStatement.aria": "Category positioning",
  "categoryStatement.line": "Not a distributor. Not a marketplace. The procurement layer for LATAM's industrial buildout.",
  "thesis.label": "Why this exists",
  "thesis.headline": "Procurement across LATAM is fragmented \u2014 and slowing down critical projects.",
  "thesis.body": "Switzh replaces fragmented supplier sourcing with a single request that aggregates supply, calculates full landed pricing (DDP), and executes procurement in one system. Switzh acts as the transaction layer for cross-border industrial procurement.",
  "hero.bestFor.label": "Best for:",
  "hero.bestFor.1": "Urgent replacements",
  "hero.bestFor.2": "Repeat procurement",
  "hero.bestFor.3": "Hard-to-find parts",
  "hero.trustLine": "Quotes in <4 hours \u2022 Full landed (DDP) pricing upfront \u2022 Tracked delivery across LATAM",
  "hero.speedLine": "Quote turnaround target: under 4 hours",
  "hero.differentiator": "Sourcing from the U.S. with structured procurement and delivery across Latin America.",
  "hero.imageBadge": "Quotes in <4 hours",
  "hero.bullet1": "Response in minutes \u2014 not hours or days",
  "hero.bullet2": "Final landed pricing (DDP) upfront",
  "hero.bullet3": "Real availability and lead times",
  "hero.bullet4": "Multiple suppliers and equivalent options",
  "hero.bullet5": "One request replaces 5\u201310 emails",
  "hero.trustMicro": "Used by contractors and procurement teams sourcing across LATAM.",
  "hero.delivery": "Typical delivery:",
  "hero.deliveryRange": "5\u201310 business days",
  "hero.deliverySuffix": "",
  "hero.avgResponse": "Avg. response",
  "hero.avgResponseValue": "< 4 hours",
  "hero.carousel.eyebrow": "What we source",
  "hero.slide.components.caption": "Fast Access Power Components",
  "hero.slide.components.alt": "Technician installing molded-case circuit breakers (Siemens 3VA, Schneider NSX, Eaton FD, ABB Tmax) inside a low-voltage switchgear cabinet \u2014 high-frequency replacement components sourced from U.S. supply for LATAM industrial buyers",
  "hero.slide.packages.caption": "Pre-Configured Power Packages",
  "hero.slide.packages.alt": "Bundled circuit breakers, contactors, overload relays and busbars staged on a U.S. distribution warehouse workbench \u2014 pre-configured power packages ready for LATAM delivery",
  "hero.slide.systems.caption": "Power Distribution Solutions",
  "hero.slide.systems.alt": "Row of UL 891 low-voltage switchboards and ATS cabinets installed in a clean industrial electrical equipment room \u2014 made-to-order U.S.-standard power distribution systems delivered into LATAM",
  "values.h2": "One request replaces 5\u201310 supplier emails",
  "values.subtitle": "Faster than traditional sourcing \u2014 U.S. supply channels, delivered pricing visibility, and cross-border coordination handled end-to-end. Built for urgent replacement and repeat industrial procurement.",
  "values.1.title": "Faster than traditional sourcing",
  "values.1.text": "One structured request reaches multiple U.S. suppliers in parallel \u2014 quotes back in hours, not days of email chasing.",
  "values.2.title": "Delivered pricing visibility",
  "values.2.text": "Product, freight, duties, and final-mile delivery in one DDP price \u2014 landed cost visible before you commit. No hidden fees.",
  "values.3.title": "Access to U.S. supply channels",
  "values.3.text": "Real availability and lead times pulled from U.S. distribution and aftermarket networks \u2014 beyond any single local catalog.",
  "values.4.title": "Cross-border coordination handled",
  "values.4.text": "Specs validated, equivalents suggested, freight, customs, and last-mile delivery managed in one workflow \u2014 ideal for urgent replacement parts.",
  "trust.h2": "Trusted by electrical contractors, maintenance teams, and procurement teams across LATAM",
  "trust.1": "Quote turnaround target: under 4 hours",
  "trust.2": "Full landed (DDP) cost before you commit",
  "trust.3": "Tracked execution from request to site delivery",
  "trust.4": "Substitute recommendations when parts are unavailable",
  "trust.footer": "Focused on switchgear, breakers, contactors, and protection devices \u2014 sourced from verified U.S. distributors and delivered DDP across LATAM.",
  "suppliers.eyebrow": "Brands we source",
  "suppliers.h2": "U.S. electrical manufacturers \u2014 ABB, Schneider, Eaton & more",
  "suppliers.subtitle": "We source components across a network of leading U.S. manufacturers and authorized distributors to secure availability and reduce lead times across LATAM.",
  "suppliers.note": "Supplier selection is based on availability, specifications, and delivery timeline across our extended U.S. network.",
  "cat.eyebrow": "Fast Access Power Components",
  "cat.h2": "U.S. switchgear components, delivered to LATAM",
  "cat.subtitle": "Breakers, MCC buckets, contactors, relays, disconnects, switchgear components, distribution panels, switchboards, bus plugs, retrofit kits, ATS / transfer switches and control gear \u2014 Siemens, Schneider Electric, Eaton and ABB, quoted in <4 hours with full landed pricing (DDP).",
  "cat.1.title": "Circuit Breakers",
  "cat.1.text": "MCCBs, ICCBs and frames \u2014 Siemens 3VA, Schneider NSX, Eaton FD, ABB Tmax \u2014 100A\u2013630A, sourced for urgent replacement and panel expansion.",
  "cat.2.title": "Contactors, Relays + MCC Buckets",
  "cat.2.text": "Schneider TeSys (LC1D), Siemens 3RT, ABB AF, Eaton XTCE \u2014 plus MCC buckets and control gear for motor-control system replacement.",
  "cat.3.title": "Disconnects + Bus Plugs",
  "cat.3.text": "Siemens HNF, Schneider HU, Eaton DH safety switches plus busway bus plugs \u2014 isolation, code compliance and tap-off expansion.",
  "cat.4.title": "Protection Devices",
  "cat.4.text": "Schneider LRD, Siemens 3RU, ABB TA overload relays, A9L / 5SD surge protection (SPD) and switchgear protection components.",
  "cat.5.title": "ATS / Transfer Switches",
  "cat.5.text": "Automatic transfer switches, transfer-switch parts and emergency backup-power replacements \u2014 sourced from U.S. supply for downtime-critical sites.",
  "cat.6.title": "Distribution Panels, Switchboards + Retrofit Kits",
  "cat.6.text": "Distribution panels, low-voltage switchboards, retrofit kits, busbar kits and connectors \u2014 for panel upgrades and capacity expansion.",
  "cat.bottom.prefix": "Most requests are for",
  "cat.bottom.highlight": "urgent, repeat, and hard-to-source",
  "cat.bottom.suffix": "components.",
  "cat.related.prefix": "Popular requests:",
  "cat.buyers.label": "Trusted by",
  "cat.buyers.list": "Electrical contractors \u00b7 Industrial plants \u00b7 Facilities teams \u00b7 Utilities \u00b7 EPC firms \u00b7 OEM panel builders \u00b7 Data centers \u00b7 Industrial operators",
  "cmp.eyebrow": "What makes us different",
  "cmp.h2": "Not a distributor \u2014 a faster access layer",
  "cmp.lead1": "Traditional sourcing relies on a single distributor. If they're out of stock or slow to respond, your project waits.",
  "cmp.lead2.prefix": "We check",
  "cmp.lead2.bold": "multiple verified U.S. suppliers at once",
  "cmp.lead2.suffix": "to find the fastest available option.",
  "cmp.trad.label": "Traditional distributor",
  "cmp.trad.title": "One supplier, one outcome",
  "cmp.trad.1": "Single supplier \u2014 single point of failure",
  "cmp.trad.2": "Slow response (often days)",
  "cmp.trad.3": "Limited inventory for hard-to-find parts",
  "cmp.trad.4": "Hidden costs at customs and freight",
  "cmp.pps.title": "Multi-supplier sourcing, faster outcomes",
  "cmp.pps.1": "Multiple verified U.S. suppliers \u2014 not just one",
  "cmp.pps.2": "Response in hours, not days",
  "cmp.pps.3": "Focused on hard-to-find and urgent components",
  "cmp.pps.4": "Full landed (DDP) pricing upfront \u2014 no surprises",
  "cmp.quote": "\u201cIf one supplier can't deliver, we find one that can.\u201d",
  "use.eyebrow": "Use cases",
  "use.h2": "When to use Switzh",
  "use.subtitle": "Reach out when local supply runs out, lead times stretch, or a project deadline is at risk.",
  "use.1": "Your supplier is out of stock",
  "use.2": "Lead times are too long (6\u201316+ weeks)",
  "use.3": "You need a replacement part urgently",
  "use.4": "You can't find a specific SKU locally",
  "use.5": "Need full landed pricing (DDP) upfront",
  "use.6": "Need a <4-hour quote with DDP delivery to LATAM",
  "how.eyebrow": "How it works",
  "how.h2": "From request to delivery in 5 steps",
  "how.step": "Step",
  "how.1.title": "Submit request",
  "how.1.text": "Buyer submits RFQ \u2014 SKU, link, or short description.",
  "how.2.title": "We aggregate supplier options",
  "how.2.text": "Switzh aggregates supplier options and confirms availability across our network (Sonepar and others).",
  "how.3.title": "Calculate DDP landed cost",
  "how.3.text": "System calculates full landed (DDP) pricing \u2014 shipping, duties, and taxes included.",
  "how.4.title": "Structured quote in <4 hours",
  "how.4.text": "Buyer receives a structured quote with confirmed pricing and delivery \u2014 typically under 4 hours.",
  "how.5.title": "Order \u2192 procurement \u2192 delivery",
  "how.5.text": "Order confirmed \u2014 Switzh executes procurement and cross-border delivery via integrated logistics (SkyPostal).",
  "how.note.prefix": "Quote turnaround target:",
  "how.note.bold": "under 4 hours",
  "tl.eyebrow": "Delivery",
  "tl.h2": "Delivery timelines",
  "tl.express.label": "Express",
  "tl.express.desc": "For urgent and time-critical sourcing.",
  "tl.standard.label": "Standard",
  "tl.standard.desc": "Optimized cost with 5\u201310 day DDP delivery.",
  "tl.unit": "days",
  "tl.note": "Based on U.S. inventory availability. Final timeline confirmed per quote, from order confirmation.",
  "tl.proof": "Sourced from verified U.S. distributors \u00b7 DDP delivery across LATAM",
  "geo.eyebrow": "LATAM coverage",
  "geo.h2": "5\u201310 day DDP delivery across LATAM, fully managed",
  "geo.subtitle": "DDP delivery with import clearance, duties, and local logistics fully managed \u2014 from U.S. sourcing to final delivery.",
  "geo.ops": "We handle international shipping, customs clearance, and last-mile delivery.",
  "geo.routesLabel": "Active delivery routes include:",
  "geo.trustMicro": "Consistent delivery across contractors, EPCs, and industrial buyers",
  "case.eyebrow": "Real use cases",
  "case.prev": "Previous case",
  "case.next": "Next case",
  "case.proof.contractor": "Real case \u2014 contractor",
  "case.proof.epc": "Real case \u2014 EPC",
  "case.proof.industrial": "Real case \u2014 industrial operator",
  "case.proof.utility": "Real case \u2014 utility project",
  "case.fromOrder": "from order confirmation",
  "case1.headline": "A contractor in Colombia needed a Schneider Electric MCCB unavailable locally.",
  "case1.sub": "Switzh sourced the exact unit from U.S. inventory and delivered in 5 days \u2014 avoiding a 4\u20136 week delay.",
  "case1.m1": "5 Days",
  "case1.m1.sub": "Instead of 4\u20136 weeks",
  "case1.m2": "1 Critical SKU",
  "case1.m2.sub": "Schneider Electric MCCB",
  "case1.m3": "On Time",
  "case1.m3.sub": "Project schedule maintained",
  "case2.headline": "A mining operator needed an obsolete Siemens relay no longer available locally.",
  "case2.sub": "Switzh located remaining U.S. stock and delivered in 6 days \u2014 preventing operational downtime.",
  "case2.m1": "6 Days",
  "case2.m1.sub": "Instead of indefinite delay",
  "case2.m2": "1 Obsolete Part",
  "case2.m2.sub": "Siemens relay",
  "case2.m3": "Zero Downtime",
  "case2.m3.sub": "Operations continued",
  "case3.headline": "An EPC contractor required a panelboard with urgent delivery to meet installation deadlines.",
  "case3.sub": "Switzh sourced from U.S. distributor inventory and delivered in 7 days.",
  "case3.m1": "7 Days",
  "case3.m1.sub": "Instead of 3\u20135 weeks",
  "case3.m2": "1 Panelboard",
  "case3.m2.sub": "Industrial distribution",
  "case3.m3": "On Schedule",
  "case3.m3.sub": "Installation completed",
  "case4.headline": "A utility project required an RMU with limited regional availability.",
  "case4.sub": "Switzh secured available U.S. stock and delivered in under 10 days.",
  "case4.m1": "10 Days",
  "case4.m1.sub": "Instead of 6\u20138 weeks",
  "case4.m2": "1 RMU",
  "case4.m2.sub": "Medium voltage distribution",
  "case4.m3": "Project Secured",
  "case4.m3.sub": "Timeline maintained",
  "qf.eyebrow": "Get pricing",
  "qf.h2": "Request a Quote",
  "qf.subtitle": "Get pricing, availability, and lead times for your request.",
  "qf.urgencyLine": "Send once \u2014 sourced across U.S. suppliers.",
  "qf.capabilityLine": "We identify matching products, equivalents, and delivery options \u2014 automatically.",
  "qf.responseBlock.title": "Expected response time",
  "qf.responseBlock.high": "High Priority (urgent): response within 4 hours",
  "qf.responseBlock.standard": "Standard: response within 24 hours",
  "qf.requestType": "What are you requesting?",
  "qf.requestType.ph": "Select request type",
  "qf.requestType.kit": "Pre-Configured Power Packages",
  "qf.requestType.components": "Fast Access Power Components",
  "qf.requestType.system": "Power Distribution Solutions",
  "qf.requestType.other": "Not sure / Other",
  "qf.product.main": "What do you need sourced?",
  "qf.product.main.helper": "Paste SKU, link, or description \u2014 we analyze specs, compatibility, and equivalents automatically.",
  "qf.submit.pricingAvailability": "Get Pricing & Availability",
  "qf.submit.priorityQuote": "Priority Quote (escalate)",
  "qf.submit.priorityQuote.helper": "Flags your request as urgent \u2014 first response targeted within 1 hour during business hours.",
  "qf.trustNetwork": "Sourced from verified U.S. distributors. Used by contractors and procurement teams across LATAM.",
  "qf.waPreferFaster": "Prefer faster response? Send via WhatsApp",
  "qf.contactHint": "Email or WhatsApp \u2014 provide at least one.",
  "qf.waCta": "Or send it on WhatsApp",
  "qf.draft.restored": "Draft restored",
  "qf.draft.clear": "Clear",
  "qf.draft.dismiss": "Dismiss",
  "qf.draft.clearConfirmTitle": "Clear this request draft?",
  "qf.draft.clearConfirmDesc": "This will reset the form. Submitted requests are not affected.",
  "qf.draft.clearConfirmDescSignedIn": "We'll clear the request fields and keep your account details (name, email, company, phone).",
  "qf.draft.clearConfirmCancel": "Keep editing",
  "qf.draft.clearConfirmAction": "Clear draft",
  "qf.draft.clearedTitle": "Draft cleared.",
  "qf.draft.clearedTitle.signedIn": "Request draft cleared.",
  "qf.draft.clearedDesc.signedIn": "Your profile details were kept.",
  "qf.draft.clearCta": "Clear draft",
  "qf.account.title": "Create an account to track this request",
  "qf.account.sub": "Track quote updates, review pricing, approve checkout, and manage future sourcing requests.",
  "qf.account.benefit1": "Track this request",
  "qf.account.benefit2": "Review quotes faster",
  "qf.account.benefit3": "Checkout faster",
  "qf.account.benefit4": "Reorder from past requests",
  "qf.account.cta": "Create account",
  "qf.account.continueGuest": "Continue without account",
  "qf.trust1": "Verified U.S. suppliers",
  "qf.noAccountRequired": "No account required. Used by contractors and procurement teams for fast quoting.",
  "qf.trust2": "Delivered across LATAM",
  "qf.trust3": "Full landed cost (DDP) \u2014 no hidden fees",
  "qf.required": "required",
  "qf.fullName": "Full Name",
  "qf.companyName": "Company Name",
  "qf.email": "Email",
  "qf.phone": "WhatsApp / Phone",
  "qf.country": "Country",
  "qf.city": "City",
  "qf.postal": "Postal / Zip Code",
  "qf.quantity": "Quantity",
  "qf.product": "Part number, link, or description",
  "qf.product.ph": "e.g. ABB MCCB XT4N, product URL, or description",
  "qf.urgency": "Delivery Urgency / Required Date",
  "qf.urgency.ph": "Select urgency",
  "qf.urgency.critical": "Critical \u2014 needed ASAP",
  "qf.urgency.express": "Express \u2014 within 1 week",
  "qf.urgency.standard": "Standard \u2014 2\u20133 weeks",
  "qf.urgency.planning": "Planning \u2014 flexible",
  "qf.urgency.urgent": "Urgent \u2014 within days",
  "qf.urgency.soon": "Soon \u2014 1\u20132 weeks",
  "qf.urgency.flexible": "Standard \u2014 flexible timing",
  "qf.alternative": "Alternative acceptable?",
  "qf.alternative.yes": "Yes \u2014 open to alternatives",
  "qf.alternative.no": "No \u2014 exact part required",
  "qf.country.ph": "Select country",
  "qf.country.colombia": "Colombia",
  "qf.country.peru": "Peru",
  "qf.country.mexico": "Mexico",
  "qf.country.brazil": "Brazil",
  "qf.country.chile": "Chile",
  "qf.country.ecuador": "Ecuador",
  "qf.country.panama": "Panama",
  "qf.country.costarica": "Costa Rica",
  "qf.country.dominicanrepublic": "Dominican Republic",
  "qf.country.other": "Other",
  "qf.section.primary": "What you need",
  "qf.section.context": "Context (optional)",
  "qf.section.delivery": "Delivery",
  "qf.section.contact": "Contact",
  "qf.section.productDetails": "Product Details",
  "qf.section.primary.micro": "Takes less than 2 minutes to submit",
  "qf.steps.label": "Step",
  "qf.steps.of": "of",
  "qf.steps.1": "Your request",
  "qf.steps.2": "Delivery",
  "qf.steps.3": "Contact",
  "qf.preSubmit.routed": "Sent once \u2014 sourced across multiple U.S. suppliers and OEM-authorized distributors",
  "qf.preSubmit.ddp": "Quote includes full landed pricing (product, shipping, duties, delivery) and equivalent options where available",
  "qf.advanced.title": "Advanced Details (optional)",
  "qf.advanced.subtitle": "Application notes, sourcing preferences, additional requirements",
  "qf.advanced.show": "Show advanced details",
  "qf.advanced.hide": "Hide advanced details",
  "qf.deliveryContact.title": "Delivery & Contact details",
  "qf.deliveryContact.subtitle": "Required \u2014 country, name, company, and email or WhatsApp.",
  "qf.deliveryContact.show": "Show delivery & contact details",
  "qf.deliveryContact.hide": "Hide delivery & contact details",
  "qf.deliveryContact.complete": "Complete",
  "qf.deliveryContact.required": "Required",
  "qf.deliveryContact.autoOpened": "Last step \u2014 add your delivery and contact details to submit.",
  "qf.intro": "Need a component fast? Submit your request below.",
  "qf.skuHint": "If you don't have the exact part number, describe the component.",
  "qf.responseMicro": "We typically respond within a few hours with availability and pricing.",
  "qf.systemLine": "Review your quote and proceed to checkout directly \u2014 no back-and-forth required.",
  "qf.notes.application": "Application / Notes",
  "qf.notes.application.ph": "Optional: replacement, project, maintenance, etc.",
  "qf.quantity.helper": "Approximate quantity is fine.",
  "qf.notes.application.helper": "Add urgency, specs, or acceptable substitutes (optional).",
  "qf.brand.preferred": "Preferred Brand (if any)",
  "qf.submit.requestQuote": "Request Quote",
  "qf.addMore": "Add More Details",
  "qf.group.contact": "Contact & order",
  "qf.group.product": "Product",
  "qf.group.specs": "Specifications",
  "qf.group.sourcing": "Sourcing",
  "qf.group.delivery": "Delivery",
  "qf.group.company": "Company",
  "qf.group.other": "Other",
  "qf.brand": "Brand",
  "qf.productType": "Product Type",
  "qf.productType.ph": "e.g. Circuit breaker",
  "qf.productLink": "Product Link",
  "qf.upload": "Upload file",
  "qf.upload.ph": "Spec sheet, photo, or PDF",
  "qf.browse": "Browse",
  "qf.voltage": "Voltage",
  "qf.phase": "Phase",
  "qf.phase.ph": "Select phase",
  "qf.phase.single": "Single phase",
  "qf.phase.three": "Three phase",
  "qf.phase.dc": "DC",
  "qf.frequency": "Frequency",
  "qf.amperage": "Amperage",
  "qf.modelSeries": "Model / Series",
  "qf.exact": "Exact Part or Equivalent",
  "qf.exact.ph": "Select preference",
  "qf.exact.exact": "Exact part only",
  "qf.exact.equivalent": "Equivalent acceptable",
  "qf.exact.either": "Either is fine",
  "qf.fullAddress": "Full Address",
  "qf.fullAddress.ph": "Street, number, building, references\u2026",
  "qf.companyType": "Company Type",
  "qf.companyType.ph": "Select company type",
  "qf.companyType.contractor": "Contractor",
  "qf.companyType.epc": "EPC",
  "qf.companyType.industrial": "Industrial / Plant",
  "qf.companyType.distributor": "Distributor",
  "qf.companyType.integrator": "Integrator",
  "qf.companyType.other": "Other",
  "qf.sku": "SKU / Part Number",
  "qf.sku.ph": "e.g. Siemens 3VA1110 or product URL",
  "qf.product.ph.optional": "Optional \u2014 describe the part if you don't have an SKU",
  "qf.hasSpecs": "Do you have full specifications?",
  "qf.hasSpecs.ph": "Select",
  "qf.hasSpecs.yes": "Yes",
  "qf.hasSpecs.no": "No \u2014 please confirm with us",
  "qf.deliveryType": "Delivery Type",
  "qf.deliveryType.ph": "Select delivery type",
  "qf.deliveryType.business": "Business / Commercial",
  "qf.deliveryType.residential": "Residential",
  "qf.taxId": "Tax ID / VAT (optional)",
  "qf.taxId.ph": "e.g. 900.123.456-7",
  "qf.preferences": "Preferences",
  "qf.businessType": "Business type",
  "qf.businessType.ph": "Select",
  "qf.typicalUsage": "Typical usage",
  "qf.typicalUsage.ph": "Select",
  "qf.orderType": "Is this for\u2026",
  "qf.orderType.ph": "Optional",
  "qf.orderType.oneTime": "One-time order",
  "qf.orderType.ongoing": "Ongoing / repeat needs",
  "qf.group.commercial": "Commercial",
  "qf.notes": "Specs, quantity, or requirements",
  "qf.notes.ph": "e.g. 24 units, 480V, delivery location",
  "qf.upload.label": "Upload spec sheet / BOM (optional)",
  "qf.upload.cta": "Choose file",
  "qf.upload.hint": "Upload drawings, specs, or BOM for faster and more accurate quoting. PDF, DOC, XLS, PNG, JPG \u00b7 20MB max.",
  "qf.upload.remove": "Remove",
  "qf.upload.uploading": "Uploading\u2026",
  "qf.upload.error.size": "File is too large. Max 20MB.",
  "qf.upload.error.type": "Unsupported file type. Use PDF, DOC, XLS, PNG, or JPG.",
  "qf.upload.error.failed": "Upload failed. Please try again.",
  "qf.submit": "Submit Parts List",
  "qf.submitting": "Sending\u2026",
  "qf.footer": "We confirm availability and respond with pricing and delivery timeline \u2014 typically within hours.",
  "qf.toast.title": "Request received",
  "qf.toast.desc": "Processing your request \u2014 matching products and suppliers now.",
  "qf.error.title": "Submission failed",
  "qf.error.desc": "There was an issue submitting your request. Please contact us via WhatsApp.",
  "qf.invalid.title": "Please fix the highlighted fields",
  "qf.invalid.desc": "We've scrolled to the first issue \u2014 required fields are marked in red.",
  "qf.invalid.inline": "Please correct the highlighted fields and try again.",
  "qf.invalid.specs": "Without an SKU, please add at least one specification or upload a photo / spec sheet.",
  "qf.invalid.alternative": "Please choose: Exact part only or Equivalent acceptable.",
  "qf.invalid.deliveryType": "Please choose Business / Commercial or Residential delivery.",
  "qf.err.quantityRequired": "Quantity is required",
  "qf.err.quantityPositive": "Quantity must be greater than 0",
  "qf.err.urgencyRequired": "Urgency is required",
  "qf.err.countryRequired": "Country is required",
  "qf.err.fullNameRequired": "Full name is required",
  "qf.err.companyRequired": "Company name is required",
  "qf.err.emailRequired": "Email is required",
  "qf.err.emailInvalid": "Invalid email address",
  "qf.err.postalInvalid": "Invalid postal code",
  "qf.err.urlInvalid": "Must be a valid URL starting with http(s)://",
  "qf.err.productRequired": "Enter a part number or describe the component",
  "qf.err.emailRequiredLong": "Email is required so we can send you the quote confirmation.",
  "wa.chip": "Fastest channel",
  "wa.h2": "Prefer WhatsApp?",
  "wa.text": "Send details \u2014 we respond with structured pricing, availability, and delivery options.",
  "wa.footer": "Typically responsive during business hours.",
  "final.h2": "Need a component fast?",
  "final.text": "Submit your request and receive availability and full landed (DDP) pricing in under 4 hours.",
  "final.cta.primary": "Get Pricing & Availability",
  "final.cta.primary.micro": "Response in < 4 hours",
  "final.cta.whatsapp.micro": "For urgent requests",
  "final.cta.bom.micro": "Send your BOM, SKUs, or specs",
  "final.trust": "Verified U.S. suppliers \u2022 5\u201310 day DDP delivery to LATAM \u2022 Full landed pricing \u2014 no hidden fees",
  "footer.tagline": "The AI-assisted sourcing layer for U.S. electrical supply",
  "footer.contact": "Contact",
  "footer.supplierPartners": "Become a supplier",
  "footer.legal": "Legal",
  "footer.explore": "Explore",
  "footer.solutions": "Solutions",
  "footer.compare": "Compare",
  "footer.buyerLogin": "Sign in",
  "footer.createAccount": "Create account",
  "footer.myAccount": "My account",
  "footer.logout": "Logout",
  "footer.supplierLogin": "Supplier login",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms",
  "footer.copy": "All rights reserved.",
  "footer.tagline2": "AI-native industrial sourcing platform",
  "newsletter.title": "Stay Updated",
  "newsletter.subtext": "Get sourcing updates for hard-to-find U.S. electrical components.",
  "newsletter.placeholder": "Enter your email",
  "newsletter.cta": "Subscribe",
  "newsletter.submitting": "Subscribing\u2026",
  "newsletter.micro": "No spam. Only relevant updates.",
  "newsletter.success": "You're subscribed.",
  "newsletter.invalid": "Please enter a valid email address.",
  "newsletter.error": "Something went wrong. Please try again.",
  "fw.aria": "Chat on WhatsApp",
  "banner.es": "View this site in Spanish?",
  "banner.pt": "View this site in Portuguese?",
  "banner.switch": "Switch",
  "banner.dismiss": "Dismiss",
  "legal.back": "Back to home",
  "legal.eyebrow": "Legal",
  "legal.lastUpdated": "Last updated:",
  "seo.home.title": "Switzh | AI-Assisted Electrical Sourcing for LATAM",
  "seo.home.desc": "Source U.S. switchgear and electrical components into LATAM faster. Switzh uses AI-assisted RFQ intake, human-reviewed sourcing, delivered pricing support, and cross-border logistics.",
  "seo.privacy.title": "Privacy Policy | Switzh",
  "seo.privacy.desc": "How Switzh collects, uses, and protects buyer data during industrial electrical sourcing and quoting.",
  "seo.terms.title": "Terms of Service | Switzh",
  "seo.terms.desc": "Commercial terms for quoting, ordering, and delivery of industrial electrical components through Switzh.",
  "seo.compare.title": "Electrical Sourcing vs Distributors (Speed Comparison)",
  "seo.compare.desc": "Compare lead times, pricing, and supplier coverage vs traditional distributors. Quotes in hours, multi-supplier sourcing, DDP delivery to LATAM.",
  "seo.requestQuote.title": "Request a Quote \u2014 Industrial Electrical Components",
  "seo.requestQuote.desc": "Send a SKU, spec sheet, or photo and get firm pricing plus availability within hours. Global supplier network, no account required.",
  "seo.howItWorks.title": "Electrical Procurement Services \u2014 From SKU to Delivery",
  "seo.howItWorks.desc": "How we source hard-to-find industrial electrical components, return firm quotes in hours, and deliver DDP to LATAM. Step-by-step process.",
  "seo.whatWeSource.title": "What We Source \u2014 Brands, SKUs & Component Categories",
  "seo.whatWeSource.desc": "Breakers, PLCs, VFDs, contactors, switchgear and sensors from ABB, Siemens, Schneider, Rockwell, Eaton \u2014 sourced fast through global suppliers.",
  "seo.instantSourceCheck.title": "Ask Switzh | AI Sourcing Assistant for Switchgear & Electrical Components",
  "seo.instantSourceCheck.desc": "Ask Switzh to interpret part numbers, BOM lines, product descriptions, or nameplate uploads and turn sourcing requests into structured RFQs for LATAM industrial buyers.",
  "seo.supplierPartners.title": "Become a Supplier Partner | Switzh Electrical Procurement",
  "seo.supplierPartners.desc": "Partner with Switzh to receive structured RFQs for U.S. electrical supply, switchgear, breakers, and components from LATAM buyers. Start manually, integrate when ready.",
  "cookie.aria": "Cookie consent",
  "cookie.title": "We value your privacy",
  "cookie.text": "We use cookies to analyze site traffic and improve your experience. You can accept or reject analytics cookies. See our",
  "cookie.privacy": "Privacy Policy",
  "cookie.accept": "Accept all",
  "cookie.reject": "Reject",
  "cookie.close": "Close",
  "footer.cookiePrefs": "Cookie preferences",
  "layers.title": "What Switzh Does",
  "layers.intro": "A fast-access procurement and pricing layer for LATAM buyers sourcing U.S. electrical supply. Components first \u2014 packages and made-to-order systems when you need them.",
  "layers.core.eyebrow": "Primary lane",
  "layers.core.title": "Fast Access Power Components",
  "layers.core.body": "Our core business: urgent, repeat, and hard-to-source U.S. components \u2014 switchgear, breakers, contactors, relays, protection devices. Quotes targeted in under 4 hours.",
  "layers.fast.eyebrow": "Bundled procurement",
  "layers.fast.title": "Pre-Configured Power Packages",
  "layers.fast.body": "Standardized bundles for repeatable use cases \u2014 faster quoting, simpler procurement, larger basket size in a single order.",
  "layers.fast.items": "Common contractor & maintenance bundles \u00b7 pre-spec'd kits",
  "layers.fast.speed": "Bundled \u2022 Faster quoting \u2022 Higher AOV",
  "layers.eng.eyebrow": "Made-to-order",
  "layers.eng.title": "Power Distribution Solutions",
  "layers.eng.body": "Made-to-order systems for planned projects with defined scope and longer lead times \u2014 not the primary lane for urgent component requests.",
  "layers.eng.items": "Switchgear \u00b7 ATS / STS \u00b7 Panels \u00b7 Power distribution systems",
  "layers.eng.scope": "Made-to-order \u2022 Defined scope \u2022 Longer cycle",
  "label.fastAccess": "Fast Access Solution \u2014 optimized for urgent sourcing",
  "label.engineered": "Power Distribution Solution \u2014 built-to-order with extended lead times",
  "label.leadFast": "Typical sourcing time: 24\u201372 hours",
  "label.leadEngineered": "Typical lead time: 2\u20138+ weeks depending on configuration",
  "trust.globalNetwork": "We source through a global network of suppliers \u2014 not limited to a single distributor or manufacturer.",
  "wws.twoWays.title": "How We Support Your Procurement",
  "wws.twoWays.sub": "Three procurement layers \u2014 pick the path that matches your situation.",
  "decision.title": "What do you need?",
  "decision.fast.title": "Fast Access Power Components",
  "decision.fast.label": "Sourced in 24\u201372h",
  "decision.fast.cta": "View Components",
  "decision.kits.title": "Pre-Configured Power Packages",
  "decision.kits.label": "Ready-to-install, faster deployment",
  "decision.kits.cta": "View Kits",
  "decision.eng.title": "Power Distribution Solutions",
  "decision.eng.label": "Built-to-order (2\u20138+ weeks)",
  "decision.eng.cta": "View Systems",
  "recent.eyebrow": "Recently sourced",
  "recent.suffix.days": "days",
  "mostReq.title": "Most Requested Power Packages",
  "mostReq.sub": "Pre-configured component bundles sourced from U.S. supply and delivered into LATAM with full landed pricing (DDP).",
  "mostReq.emergency.title": "Emergency Replacement Kit",
  "mostReq.emergency.body": "Pre-configured kit for downtime scenarios \u2014 breaker, contactor, overload relay, and accessories sourced together for fastest LATAM delivery.",
  "mostReq.panel.title": "Panel Upgrade Kit",
  "mostReq.panel.body": "Bundled main + branch breakers, busbars, and connectors for U.S.-standard panel upgrades, delivered DDP into LATAM.",
  "mostReq.automation.title": "Automation Control Kit",
  "mostReq.automation.body": "Contactor + overload + protection bundle from Schneider TeSys, Siemens 3RT, ABB AF \u2014 pre-validated for control system replacement.",
  "mostReq.cta": "Request Package Quote",
  "mostReq.badge": "Primary",
  "bto.title": "Built-to-Order Systems",
  "bto.body": "These systems are configured based on project requirements and sourced from global suppliers. Lead times vary depending on specifications and availability.",
  "bto.leadLabel": "Typical Lead Times",
  "bto.leadValue": "2\u20138+ weeks",
  "quoteResp.title": "Response expectation",
  "quoteResp.high.label": "High Priority Requests",
  "quoteResp.high.value": "Response within 4 hours",
  "quoteResp.std.label": "Standard Requests",
  "quoteResp.std.value": "Response within 24 hours",
} as const;

export default dict;
